import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=d4632efe&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=d4632efe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4632efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4632efe')) {
      api.createRecord('d4632efe', component.options)
    } else {
      api.reload('d4632efe', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=d4632efe&scoped=true", function () {
      api.rerender('d4632efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/signature/Main.vue"
export default component.exports